import { from } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BROADCAST_CREATE_SOURCES, GET_BRANDING_SETTINGS } from 'actions/Types';
import { SOURCE_CREATE, SYNC_BRANDING_SETTINGS } from 'store/eventConstants';
import { sendToDatadog } from '@studio/logger';

const loggerName = 'director-middleware-notifyDirectors';

/**
 * Target specific actions for emitting notifying socket events
 *
 * This should be used instead of calling socket.emit(''', {notifyingDirector})
 * directly inside of actions
 *
 * @param {{ emit: Function }} socket
 */
function notifyDirectors(socket) {
  return store => next => async action => {
    const targetedActions = [
      `${BROADCAST_CREATE_SOURCES}_SUCCESS`,
      `${GET_BRANDING_SETTINGS}_SUCCESS`
    ];

    from([action])
      .pipe(filter($action => targetedActions.includes($action.type)))
      .subscribe(async $action => {
        const {
          broadcast,
          meeting: { attendeeResponse }
        } = store.getState();

        const broadcastId = broadcast?._id;
        const notifyingDirector = attendeeResponse?.Attendee.AttendeeId;

        const { type, payload } = $action;

        function emitSocketEvent(socketEvent, payload) {
          socket.emit(socketEvent, {
            broadcastId,
            notifyingDirector,
            ...payload
          });
        }

        if (type === `${BROADCAST_CREATE_SOURCES}_SUCCESS`) {
          emitSocketEvent(SOURCE_CREATE, payload);
        }

        if (type === `${GET_BRANDING_SETTINGS}_SUCCESS`) {
          if (broadcast?.settings?.branding) {
            sendToDatadog(
              loggerName,
              { brandingSettings: payload },
              'SYNC_BRANDING_SETTINGS event dispatched',
              false
            );

            emitSocketEvent(SYNC_BRANDING_SETTINGS, {
              broadcastId,
              brandingSettings: payload
            });
          }
        }
      });

    return next(action);
  };
}

export default notifyDirectors;
